export const errorMessage = (type:string) => {
  return `An unknown error occurred ${type}, please try again.`;
};